import React from 'react';

import { EventFinderApi, SitePatientEncounterApi } from '../../../../api';
import LogRowStatusHistoryApi from '../../../../api/patient/LogRowStatusHistoryApi';
import ModalBoxes from '../../../../common/feedback/ModalBoxes/ModalBoxes';
import NotificationManager from '../../../../common/notifications/NotificationManager';
import { DATA_SAVED } from '../../../../constants/notificationMessages';
import { onRequestError } from '../../../../services/handlers';

import CancelEncounterModal from './EncounterDescNew/CancelEncounterModal';
import CancelLogRowModal from './EncounterDescNew/CancelLogRowModal';

export const IS_SCHEDULED_ENCOUNTER = 'IS_SCHEDULED_ENCOUNTER';
export const IS_DEFAULT_ENCOUNTER = 'IS_DEFAULT_ENCOUNTER';

function _doCancelSitePatientEncounter(ssuPatientId, ssuPatientEncounterId, comment, cancelActiveEvents) {
  const payload = {
    reason: comment,
    cancelActiveEvents: cancelActiveEvents
  };
  return SitePatientEncounterApi.cancelSitePatientEncounter(ssuPatientId, ssuPatientEncounterId, payload)
    .then(res => {
      NotificationManager.success(DATA_SAVED);
      return res;
    })
    .catch(onRequestError);
}

function _doCancelScheduledSitePatientEncounter(comment, ssuPatientId, encounterEvent, cancelActiveEvents) {
  const payload = {
    reason: comment,
    cancelActiveEvents: cancelActiveEvents
  };
  return SitePatientEncounterApi.checkinAndCancelSitePatientEncounter(ssuPatientId, encounterEvent?.id, payload)
    .then(res => {
      NotificationManager.success(DATA_SAVED);
      return res;
    })
    .catch(onRequestError);
}

function _doReopenSitePatientEncounter(ssuPatientId, ssuPatientEncounterId) {
  return SitePatientEncounterApi.reopenSitePatientEncounter(ssuPatientId, ssuPatientEncounterId)
    .then(res => {
      NotificationManager.success(DATA_SAVED);
      return res;
    })
    .catch(onRequestError);
}

/**
 * @deprecated Please use _cancelPatientEncounter_ instead
 */
export function cancelSitePatientEncounter(ssuPatientEncounterId, ssuPatientId, encounterKey, func, encounterName) {
  EventFinderApi.getEncounterEvents(ssuPatientId, encounterKey, ssuPatientEncounterId).then(function({
    data: appointments
  }) {
    const cancelEncounterModal = ModalBoxes.open({
      component: (
        <CancelEncounterModal
          onConfirm={(comment, cancelActiveEvents) => {
            _doCancelSitePatientEncounter(ssuPatientId, ssuPatientEncounterId, comment, cancelActiveEvents).then(() => {
              func();
              cancelEncounterModal.close();
            });
          }}
          encounterName={encounterName}
          appointments={appointments}
        />
      )
    });
  });
}

export function cancelLogRow(
  studyId,
  ssuPatientId,
  itemGroupTemplateId,
  itemGroupTemplateVersionId,
  rowId,
  itemGroupName,
  domainName
) {
  ModalBoxes.open({
    component: (
      <CancelLogRowModal
        studyId={studyId}
        ssuPatientId={ssuPatientId}
        itemGroupTemplateId={itemGroupTemplateId}
        itemGroupTemplateVersionId={itemGroupTemplateVersionId}
        rowId={rowId}
        itemGroupName={itemGroupName}
        domainName={domainName}
      />
    )
  });
}

export function reopenAdverseEventLogRow(
  studyId,
  ssuPatientId,
  itemGroupTemplateId,
  itemGroupTemplateVersionId,
  rowId
) {
  return new Promise((resolve, reject) => {
    LogRowStatusHistoryApi.reopenAdverseEventLogRow(
      studyId,
      ssuPatientId,
      itemGroupTemplateId,
      itemGroupTemplateVersionId,
      rowId
    )
      .then(() => {
        NotificationManager.success('Row Reopened successfully');
        resolve();
      })
      .catch(err => reject(err));
  });
}

export function cancelPatientEncounter(
  ssuPatientEncounterId,
  ssuPatientId,
  encounterEvent,
  encounterName,
  func,
  encounterActionType,
  currentStudy
) {
  const { protocolEncounterId } = encounterEvent;
  EventFinderApi.getEncounterEvents(ssuPatientId, protocolEncounterId, ssuPatientEncounterId).then(function({
    data: appointments
  }) {
    const cancelEncounterModal = ModalBoxes.open({
      component: (
        <CancelEncounterModal
          onConfirm={(comment, cancelActiveEvents) => {
            switch (encounterActionType) {
              case IS_SCHEDULED_ENCOUNTER:
                _doCancelScheduledSitePatientEncounter(comment, ssuPatientId, encounterEvent, cancelActiveEvents).then(
                  () => {
                    func();
                    cancelEncounterModal.close();
                  }
                );
                break;
              case IS_DEFAULT_ENCOUNTER:
                _doCancelSitePatientEncounter(ssuPatientId, ssuPatientEncounterId, comment, cancelActiveEvents).then(
                  () => {
                    func();
                    cancelEncounterModal.close();
                  }
                );
                break;
              // eslint-disable-next-line no-fallthrough
              default:
                throw new Error('EncounterActionType not chosen');
            }
          }}
          encounterName={encounterName}
          appointments={appointments}
          currentStudy={currentStudy}
        />
      )
    });
  });
}

export function reopenSitePatientEncounter(ssuPatientId, patientId, func) {
  ModalBoxes.confirm({
    content: ' Are you sure you want to Reopen the Encounter?',
    confirmButton: 'Yes',
    cancelButton: 'No'
  }).then(
    () =>
      _doReopenSitePatientEncounter(ssuPatientId, patientId).then(() => {
        func();
      }),
    () => {}
  );
}
